import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('PrivacyPolicyController', PrivacyPolicyController);

    function PrivacyPolicyController() {}
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/privacy-policy/privacy-policy.controller.ts